<template>
  <v-layout row wrap class="px-0">
    <v-flex xs12>
      <v-data-table no-data="пусто"
        :headers="headers"
        :items="transfers"
        :search="search"

        item-key="transferid" :sort-by="sortBy"
        :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        dense text
      >
        <template v-slot:item.cts="{ item }">
          {{ dateFormat(item.cts) }}
        </template>
        <template v-slot:item.bal="{ item }">
          {{ rubles(item.result - item.amount) }}
        </template>
        <template v-slot:item.amount="{ item }">
          <div v-if="parseInt(item.amount) < 0" class="amount-minus">
            <v-icon right color="red">
              arrow_drop_down
            </v-icon>
            <span>{{ rubles(item.amount) }}</span>
          </div>
          <div v-else class="amount-plus">
              <v-icon right color="green">
                arrow_drop_up
              </v-icon>
              <span>+{{ rubles(item.amount) }}</span>
          </div>
        </template>
        <template v-slot:item.result="{ item }">
          <v-icon right v-if="parseInt(item.amount) < 0" color="red">
            arrow_drop_down
          </v-icon>
          <v-icon right v-else color="green">
            arrow_drop_up
          </v-icon>
          ={{ rubles(item.result) }}
        </template>
        <template v-slot:item.purposetitle="{ item }">
          <v-btn
            v-if="item.purposetitle"
            text small color="primary" class="caption"
            @click="$emit('search', item.purposetitle)"
          >{{ item.purposetitle }}</v-btn>
          <v-btn
            v-if="item.ancestorid"
            text small color="secondary" class="caption"
            @click="$emit('search', item.ancestorid)"
          >{{ item.ancestorid }}</v-btn>
        </template>
        <template v-slot:item.commentary="{ item }">
          <v-btn v-if="item.checkuid"
          small text color="primary" class="caption"
          @click="showCheck(item.checkuid)"
          ><v-icon small left>receipt</v-icon> чек</v-btn>
          {{ item.commentary }}
        </template>
        <template v-slot:item.activityid="{ item }">
          {{ item.orgid }}, {{ item.activitytypeid }}
        </template>
      </v-data-table>
    </v-flex>
    <v-dialog
      v-model="dialogCheck"
      scrollable
      max-width="900px"
      transition="dialog-transition"
      v-if="check"
    >
      <v-card>
        <v-card-title v-if="check" class="title">
          <b>Чек</b>&nbsp; {{check.checkuid}} @&nbsp;<b>{{dateFormat(check.cts)}}</b>
          <v-spacer></v-spacer>
          <v-btn text icon @click="dialogCheck=false"><v-icon>close</v-icon></v-btn>
        <br>
        </v-card-title>
        <v-card-text v-if="check" class="pt-0 px-3">
          <v-container grid-list-xs>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="pl-0">Данные:</v-subheader>
                <span class="fixedcharscaption">Столовая: </span>&nbsp; <b>{{check.cafeid}}</b><br>
                <span class="fixedcharscaption">сумма (+комиссия): </span>&nbsp; <b>{{rubles(check.amount)}} руб</b><br>
                <span class="fixedcharscaption">комиссия: </span>&nbsp; {{rubles(check.fee)}} руб<br>
                <span class="fixedcharscaption">комиссия, ставка: </span>&nbsp; {{check.feerate}} %<br>
                <br>
                <span class="fixedcharscaption">отменено?: </span>&nbsp; {{check.rolledback}} <br>
                <span class="fixedcharscaption">cafeid: </span>&nbsp; {{check.cafeid}} <br>
                <span class="fixedcharscaption">ФИО: </span>&nbsp; {{check.fullname}} <br>
                <span class="fixedcharscaption">комплекс?: </span>&nbsp; {{check.iscomplex}} <br>
                <span class="fixedcharscaption">тип продажи: </span>&nbsp; {{check.saletypeid}} <br>
                <i class="grey--text">(1-карта, 2-касса, 3-сотрудники, >3-бесплатные типы)</i> <br />
                <br>
                <v-subheader class="pl-0">Трансферы:</v-subheader>
                <span class="fixedcharscaption">списание: </span>&nbsp; <v-btn v-if="check.tid !== null" text small class="my-0" color="primary" @click="$emit('search', check.tid)">{{check.tid}}</v-btn> <br />
                <span class="fixedcharscaption">комиссия: </span>&nbsp; <v-btn v-if="check.feeid !== null" text small class="my-0" color="primary" @click="$emit('search', check.feeid)">{{check.feeid}}</v-btn> <br />
                <span class="fixedcharscaption">отмена: </span>&nbsp; <v-btn v-if="check.rbid !== null" text small class="my-0" color="primary" @click="$emit('search', check.rbid)">{{check.rbid}}</v-btn> <br />
                <span class="fixedcharscaption">отмена, комиссия: </span>&nbsp; <v-btn v-if="check.feerbid !== null" text small class="my-0" color="primary" @click="$emit('search', check.feerbid)">{{check.feerbid}}</v-btn> <br />
              </v-flex>
              <v-flex xs6 style="border-left: 1px solid #ddd" class="pl-5">
                <v-subheader class="pl-0">Продажи товаров: {{ rubles((check.products || []).reduce((r, x) => r + x.price, 0)) }}</v-subheader>
                <span v-for="p in check.products"><b>{{rubles(p.price)}} - </b>{{p.title}}<br /></span>
                <span v-if="check.rolledback">ЧЕК ОТМЕНЁН</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="warning"
            text
            :disabled="check.rolledback || !asAdmin"
            @click="rollbackCheck"
          >
            <v-icon>warning</v-icon>
            Отменить чек
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCheck=false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ListTransfers',
  props: [ 'transfers', 'purposes', 'sort-by', 'search', 'as-admin' ],
  data: () => ({
    headers: [
      { text: 'id', value: 'transferid' },
      { text: 'дата', value: 'cts', width: '150' },
      { text: 'баланс', value: 'bal', sortable: 'false' },
      { text: 'сумма', value: 'amount' },
      { text: 'результат', value: 'result' },
      { text: 'назначение', value: 'purposetitle' },
      { text: 'комментарий', value: 'commentary', },
      { text: 'получатель', value: 'activityid', },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 15, 100, { text:'Все', value:-1 } ]
    },
    itemsPerPage: 15,
    check: null,
    dialogCheck: null
  }),
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    async showCheck (checkuid) {
      try {
        const { meta, check } = await this.$store.dispatch('sioRequest', {
          topic: 'find-check',
          pl: { checkuid }
        })
        this.$store.dispatch('snack', meta)
        this.check = check
        this.dialogCheck = true
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async rollbackCheck () {
      try {
        const { fullname, checkid } = this.check
        await this.$store.dispatch('confirm', `Отменить чек ${fullname}? (Действие будет записано в журнал)`)
        const { meta, check } = await this.$store.dispatch('sioRequest', {
          topic: 'rollback-check',
          pl: { checkid }
        })
        this.$store.dispatch('snack', meta)
        this.check = check
        this.dialogCheck = true
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    }
  }
}
</script>

<style lang="css">
  .fixedcharscaption {
    display: inline-flex;
    width: 20ch;
  }
</style>
